import api from './apiClient';

const apiCreateBillingTopupCheckout = async ({ email, userIp } = {}) => {
    const response = await api.post('/api/captions/billing/create-topup-checkout', {
        email,
        userIp,
    });
    return response.data;
};

export default apiCreateBillingTopupCheckout;
